import '@style/common/main-style'

import '@style/common/button.css'
import '@style/components/template/Card/index.css'

import '@core/components/home/Hero'
import '@core/components/template/skeleton/card'

import './index.css'

import { Hero } from '@core/components/home/Hero'
import { deletePage } from '@utils/browserTest.ts'
import { useHome } from '@core/composables/useHome.ts'
import { loadChapters } from '@service/chapters.ts'
import { generateHomeElements } from '@core/views/home/generate.ts'
import { notify } from '@utils/notify.ts'

document.addEventListener('DOMContentLoaded', () => {
  deletePage().then(() => {
    if (import.meta.env.DEV) {
      generateHomeElements(document)
    }

    const { initChapterNewsOnClient, initDescriptionCards } = useHome()
    loadChapters({ limit: '6' })
      .then((chapters) => {
        void initChapterNewsOnClient(document.querySelector<HTMLUListElement>('main ul')!, chapters.data)
      })
      .catch((error: string) => {
        void notify(error, 'Error')
      })

    if (import.meta.env.DEV) {
      void initDescriptionCards(document, document.querySelector<HTMLUListElement>('section:last-of-type ul')!)
    }

    const hero = new Hero({
      heroContainer: document.querySelector<HTMLElement>('#hero-container'),
      canvas: document.querySelector<HTMLCanvasElement>('#hero-container canvas'),
    })

    window.addEventListener('resize', () => {
      setTimeout(() => {
        hero.init()
      }, 250)
    })

    // Lancer l'animation
    hero.init()

    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      hero.animate()
    } else {
      hero.drawConnect()
    }
  })
})
